export default "__VITE_ASSET__C5RN1V$s__"